module.exports = __webpack_public_path__ + "img/Il-Tabacchificio.560517dc.png";